import React from 'react';
import styled from 'styled-components';
import { FaUser } from 'react-icons/fa';

const dimensionKeys = ['d', 'i', 's', 'c']
const dimensionName = {
    [dimensionKeys[0]]: 'Dominance',
    [dimensionKeys[1]]: 'Influence',
    [dimensionKeys[2]]: 'Steadiness',
    [dimensionKeys[3]]: 'Compliances',
}
const intepretationCategory = ['SR', 'R', 'RA', 'T', 'ST']
const diffSegmentTable = {
    [dimensionKeys[0]]: [
        [-27, -15],
        [-14, -12],
        [-11, -8],
        [-7, -5],
        [-4, -1],
        [0, 5],
        [6, 27]
    ],
    [dimensionKeys[1]]: [
        [-26, -6],
        [-5, -3],
        [-2, 0],
        [1, 2],
        [3, 5],
        [6, 7],
        [8, 28]
    ],
    [dimensionKeys[2]]: [
        [-27, -5],
        [-4, -1],
        [0, 2],
        [3, 5],
        [6, 8],
        [9, 11],
        [12, 26]
    ],
    [dimensionKeys[3]]: [
        [-26, -9],
        [-8, -6],
        [-5, -3],
        [-2, -1],
        [0, 2],
        [3, 5],
        [6, 24]
    ]
}
const diffTable = {
    [dimensionKeys[0]]: [
        [-24, -13],
        [-12, -6],
        [-5, 1],
        [2, 9],
        [10, 24]
    ],
    [dimensionKeys[1]]: [
        [-24, -10],
        [-9, -5],
        [-4, 1],
        [2, 7],
        [8, 24]
    ],
    [dimensionKeys[2]]: [
        [-24, -9],
        [-8, -4],
        [-3, 2],
        [3, 8],
        [9, 24]
    ],
    [dimensionKeys[3]]: [
        [-24, -9],
        [-8, -4],
        [-3, 2],
        [3, 8],
        [9, 24]
    ]
}

const Header = styled.div`
    color: white;
    width: 100%;
    display:block;
    margin: 10px 0;
`
const Container = styled.div`
    text-align: -webkit-center;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 24px;
    margin: 24px 0;
`
const Heading = styled.h3`
    margin-bottom: 4px;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    /* identical to box height, or 140% */

    font-feature-settings: 'haln' on;

    /* White */

    color: #FFFFFF;
`
const SubHeading = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    letter-spacing: 0.2px;
    font-feature-settings: 'haln' on;

    /* Twilight/Base */

    color: #001E4D;
    margin: 10px 0;
`
const ContainerIcon = styled.div`
    line-height: 32px;
    align-items: center;
    vertical-align: middle;
    display:flex;
    background: #FDF1E6;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    color: #FE7762;
    padding: 8px;
`
const PersonalityText = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    text-align: center;
    letter-spacing: 0.4px;
    font-feature-settings: 'haln' on;

    /* Twilight/Base */

    color: #001E4D;
`
const TableRowHead = styled.tr`
    width: 100%;
    background: #E6E9EC;
`
const TableHead = styled.th`
    color: #6F809A;
    padding: 16px;

    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    letter-spacing: 0.5px;
    font-feature-settings: 'haln' on;
`
const TableHeadColumn = styled.th`
    color: #6F809A;
    padding: 14px;

    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    letter-spacing: 0.5px;
    font-feature-settings: 'haln' on;
    border-bottom: 1px solid #E6E9EC;
`
const TableHeadClean = styled.th`
    color: #6F809A;
    padding-bottom: 14px;

    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    letter-spacing: 0.5px;
    font-feature-settings: 'haln' on;
`
const Table = styled.table`
    width: 100%;
    text-align: left;
    border-radius: 2px 2px 0 0;
    border-collapse: separate;
    border-spacing: 0;
`
const leftBorder = {
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px'
}
const rightBorder = {
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px'
}

const ExplIcon = styled.div`
    margin-bottom: 2px;
    justify-content: center;
    background: #FE7762;
    border-radius: 6px;
    line-height: 32px;
    align-items: center;
    vertical-align: middle;
    display: inline-flex;
    margin-right: 10px;
    width: 24px;
    height: 24px;
    color: white;
    font-weight: 600;
    font-size: 12px;
`

export default function (props) {
    const { result } = props
    const { results, highestDimension } = calculateResult(result)

    if (results.length <= 0) return (<Header>
        <Heading>Hasil Assessment</Heading>
        <span>Tidak ditemuka</span>
    </Header>
    )
    return <div style={{ textAlign: "left" }}>
        <Header>
            <Heading>Hasil Assessment</Heading>
            <span style={{ color: "#C3CFC9" }}>Hasil assessment kamu</span>
            <Container>
                <div style={{ color: "#001E4D" }}>
                    <ContainerIcon><FaUser style={{ margin: "auto" }} fontSize="24px" /></ContainerIcon>
                    <br />
                    <PersonalityText>Personality kamu</PersonalityText>
                </div>
                <h3 style={{ color: "#FE7762", textTransform: 'capitalize' }}>{highestDimension}</h3>
                <p style={{ color: "#374F74" }}>Kamu memiliki personality tertinggi yaitu: {highestDimension}. Baca selengkapnya <a href="https://pemimpin.id/tips-ini-bantu-jaga-produktifitas-tim-kerjamu-berani-coba/">di sini</a></p>
            </Container>
        </Header>
        <div>
            <SubHeading>Detail Hasil</SubHeading>
            <Container>
                <Table>
                    <TableRowHead>
                        <TableHead style={leftBorder}>Summary</TableHead>
                        <TableHead>D</TableHead>
                        <TableHead>I</TableHead>
                        <TableHead>S</TableHead>
                        <TableHead style={rightBorder}>C</TableHead>
                    </TableRowHead>
                    {results.map(v => (
                        <tr>
                            <TableHeadColumn style={{ textTransform: 'capitalize' }}>{v[0]}</TableHeadColumn>
                            <TableHeadColumn>{v[1]}</TableHeadColumn>
                            <TableHeadColumn>{v[2]}</TableHeadColumn>
                            <TableHeadColumn>{v[3]}</TableHeadColumn>
                            <TableHeadColumn>{v[4]}</TableHeadColumn>
                        </tr>))}
                </Table>
            </Container>
        </div>
        <div>
            <SubHeading>Keterangan</SubHeading>
            <Container>
                <Table>
                    <tr>
                        <TableHeadClean><ExplIcon><span>ST</span></ExplIcon>Sangat Tinggi</TableHeadClean>
                        <TableHeadClean><ExplIcon><span>SR</span></ExplIcon>Sangat Rendah</TableHeadClean>
                    </tr>
                    <tr>
                        <TableHeadClean><ExplIcon><span>T</span></ExplIcon>Tinggi</TableHeadClean>
                        <TableHeadClean><ExplIcon><span>R</span></ExplIcon>Rendah</TableHeadClean>
                    </tr>
                    <tr>
                        <TableHeadClean><ExplIcon><span>RA</span></ExplIcon>Rata-Rata</TableHeadClean>
                    </tr>
                </Table>
            </Container>
        </div>

    </div>
}
function calculateResult(result) {
    const results = []
    const dimensionValues = []
    for (const dimension of dimensionKeys) {
        const resultDimension = result[dimension]
        if (!resultDimension) return []
        const { most: uMost, least: uLeast } = resultDimension
        const most = uMost || 0
        const least = uLeast || 0
        const difference = most - least
        const intepretation = intepretationCategory[diffTable[dimension].findIndex(([low, high]) => difference >= low && difference <= high)]
        const segment = diffSegmentTable[dimension].findIndex(([low, high]) => difference >= low && difference <= high)
        dimensionValues.push({ dimension, difference, most, least, intepretation, segment })
    }
    const rows = ['most', 'least', 'difference', 'intepretation']
    for (const rowName of rows) {
        results.push([rowName, ...dimensionValues.map(v => v[rowName])])
    }
    const highestDimension = dimensionName[dimensionValues.reduce((prev, current) => (prev.segment > current.segment) ? prev : current).dimension]
    return { results, highestDimension }
}